module.exports = __webpack_public_path__ + "assets/group-tevams.14bda237.svg";